<template>
    <FormSection :full-height="false" :application="application">
        <template #content>
            <section class="p-5 d-flex flex-column text-center text-primary" v-if="isSaveInProgress">
                <i class="far fa-save fa-7x me-2 animated slow flash infinite"></i>
                <div class="big-text mt-1">
                    <b>Save Implantable Device in Progress...</b>
                </div>
            </section>
            <section class="p-2 px-4" v-if="!isSaveInProgress">
                <div class="d-flex">
                    <div class="form-group col-6">
                        <label for="unique-device-identifier">
                            Unique Device Identifiers (UDI)
                            <span class="text-danger">*</span>
                            <a
                                tabindex="0"
                                href="javascript:void(0);"
                                role="button"
                                v-custom-popover="{ content: UDITooltip }"
                            >
                                <i class="fas fa-info-circle text-primary font-size-xs"></i>
                            </a>
                        </label>
                        <input
                            class="form-control"
                            v-model="udi"
                            type="text"
                            :disabled="isValidateInProgress"
                            @blur="v$.udi.$touch()"
                        />
                        <span v-if="v$.udi.$error" class="field-invalid">UDI is required.</span>
                    </div>
                    <template v-if="isDeviceValidated">
                        <div class="form-group col-3">
                            <label for="date-of-implant"> Date of Implant </label>
                            <DatePicker :getDate="handleDateChange">
                                <div class="input-group date datepickerInput">
                                    <input
                                        type="text"
                                        name="date-of-implant"
                                        class="form-control"
                                        :value="formatDateInput(implantableDevice.DateOfImplant)"
                                        placeholder="MM/DD/YYYY"
                                        autocomplete="off"
                                        @change="handleDateInputChange"
                                    />
                                    <div class="input-group-addon input-group-append">
                                        <div class="input-group-text">
                                            <i class="fa fa-calendar"></i>
                                        </div>
                                    </div>
                                </div>
                            </DatePicker>
                        </div>
                        <div class="form-group col-3">
                            <label for="status"> Status </label>
                            <select class="form-select" v-model="implantableDevice.DeviceStatus">
                                <option :value="null">Select Status</option>
                                <option :value="value.value" v-for="(value, key) in deviceStatusEnum" :key="key">
                                    {{ value.name }}
                                </option>
                            </select>
                        </div>
                    </template>
                </div>
                <button
                    type="button"
                    class="btn btn-primary btn-md mb-2"
                    v-if="!isDeviceValidated && !isValidateInProgress"
                    @click="validateUdi()"
                >
                    Validate Device
                </button>
                <button type="button" class="btn btn-primary btn-md ms-3" v-if="isValidateInProgress" :disabled="true">
                    Validating...
                </button>
                <div class="col-12" v-if="isDeviceValidated">
                    <ImplantableValidationSection :implantable-device="implantableDevice" />
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script src="./ImplantableDeviceForm.ts" />
